<template>
  <v-combobox
    v-model="value"
    class="combobox"
    :items="webapps"
    browser-autocomplete="on"
    :placeholder="$t('serverModel.components.field.selectDefaultWebApp.selectWebApp','Select webapp')"
    :item-text="mainProperty"
    :item-value="idProperty"
    :loading="$asyncComputed.webappsResponse.updating"
    :search-input.sync="quickSearch"
    :clearable="clearable"
    chips
    return-object />
</template>

<script>
import { debounce } from 'lodash'
import { dataSourceMixin } from 'schema-view/src/mixins/dataSourceMixin'
import { fieldMixin } from 'schema-view/src/mixins/fieldMixin'
import { profileDataSource } from '../../services'

export default {
  mixins: [dataSourceMixin, fieldMixin],
  props: {
    rules: {
      type: Array,
      required: false,
      default () {
        return []
      }
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  asyncComputed: {
    webappsResponse () {
      return this.item && profileDataSource.listChildren(this.item, 'webapps', this.requestOptions)
    }
  },
  data () {
    return {
      serverSearch: null,
      quickSearch: null,
      requestOptions: {}
    }
  },
  computed: {
    webapps () {
      return this.webappsResponse && this.webappsResponse.content
    }
  },
  methods: {
    remove (item) {
      this.value = null
    }
  },
  created () {
    this.quickSearchDebounced = debounce(() => {
      this.requestOptions = {
        quickSearch: this.quickSearch
      }
    }, 500)
  },
  watch: {
    value (newValue, oldValue) {
      if (newValue && !newValue.id) {
        this.$nextTick(() => {
          this.value = oldValue
        })
      }
    },
    quickSearch: {
      immediate: true,
      handler () {
        this.quickSearchDebounced && this.quickSearchDebounced()
      }
    }
  }

}
</script>
